// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_switchContainer__cAXjo {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: auto;
  margin-top: 8px;
  margin-bottom: 8px;
}

.styles_switchTitle__Jca56 {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_switchText__qwNY4 {
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding-left: 5px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/AppSwitch/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EAEA,YAAA;EAEA,eAAA;EACA,kBAAA;AADJ;;AAKE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAKJ,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AANA;;AAQE;EAEF,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AANA","sourcesContent":[".switchContainer {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    // width: 48%;\n    height: auto;\n    // margin-left: 2%;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    \n  }\n  \n  .switchTitle {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    // color: #707070;\n    // margin-bottom: 13px;\n    // color: #000;\n\nfont-size: 17px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n  }\n  .switchText{\n    // color: rgba(0, 0, 0, 0.50);\nfont-size: 13px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\npadding-left:5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switchContainer": `styles_switchContainer__cAXjo`,
	"switchTitle": `styles_switchTitle__Jca56`,
	"switchText": `styles_switchText__qwNY4`
};
export default ___CSS_LOADER_EXPORT___;
